import { PageHeaderWrapper } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import { DocumentsStatusProgress } from "../StatusProgress";
import { useDocumentsPageApiContext } from "../useApiProvider";
import { DocumentsPageHeaderSkeleton } from "./Skeleton";
import { DocumentsPageHeaderTopRow } from "./TopRow";
import { useDocumentsPageHeader } from "./useHeader";

export function DocumentsPageHeader() {
  const {
    mandatoryRequirementsQuery: { isLoading },
  } = useDocumentsPageApiContext();

  const {
    variant,
    completedQualificationWorkerRequirements,
    totalQualificationWorkerRequirements,
  } = useDocumentsPageHeader();

  return (
    <PageHeaderWrapper variant="tertiary">
      <Stack spacing={1}>
        <DocumentsPageHeaderTopRow />
        <Box sx={{ paddingX: 7, paddingBottom: 7 }}>
          {isLoading ? (
            <DocumentsPageHeaderSkeleton />
          ) : (
            <DocumentsStatusProgress
              variant={variant}
              completedDocuments={completedQualificationWorkerRequirements?.length ?? 0}
              totalDocuments={totalQualificationWorkerRequirements ?? 0}
            />
          )}
        </Box>
      </Stack>
    </PageHeaderWrapper>
  );
}
